//动态加载sections文件夹下的所有组件
import { defineAsyncComponent } from "vue";
import path from 'path'
export default {
  install(app) {
    // 遍历sestions文件下所有组件模块
        const components = import.meta.glob("./*.vue")

        // 遍历组件模块实现自动注册
        for (const [key, value] of Object.entries(components)) {
            const name = key.match(/([^/]+)\.vue$/)?.[1];
            // 拼接组件注册的 name
           const componentName = key.split("/").pop().split(".vue").shift()

           // 通过 defineAsyncComponent 异步导入指定路径下的组件
           app.component(componentName, defineAsyncComponent(value))
        }
  }
};
